'use client'

import { sendGTMEvent } from '@next/third-parties/google'
import { useEffect, useRef } from 'react'

export interface NoResultsSearchEventProps {
  readonly searchTerm?: string
  readonly area?: string
  readonly category?: string
}

/**
 * Dispara o evento `nenhum_curso_encontrado` para o dataLayer/GTM sempre que
 * o aviso de "Nenhum curso encontrado!" é exibido (busca do header ou
 * listagem de cursos sem resultados).
 *
 * No GTM, crie um Trigger "Custom Event" com o nome `nenhum_curso_encontrado`
 * e associe a Tag correspondente (ex: evento de GA4).
 */
export function NoResultsSearchEvent({
  searchTerm,
  area,
  category,
}: NoResultsSearchEventProps) {
  const hasTrackedRef = useRef(false)

  useEffect(() => {
    if (hasTrackedRef.current) {
      return
    }
    hasTrackedRef.current = true

    sendGTMEvent({
      event: 'nenhum_curso_encontrado',
      ...(searchTerm ? { search_term: searchTerm } : {}),
      ...(area ? { area } : {}),
      ...(category ? { category } : {}),
    })
  }, [searchTerm, area, category])

  return null
}
